import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FileOpenOutlinedIcon from "@mui/icons-material/FileOpenOutlined";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import LocalPrintshopTwoToneIcon from "@mui/icons-material/LocalPrintshopTwoTone";
import LowPriorityOutlinedIcon from "@mui/icons-material/LowPriorityOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

import FillColorSeparateIcon from "components/UI/icons/FillColorSeparateIcon";
import { ExpertEstmStatusEnum } from "core/enums";

const EstimateViewerContextMenuProjectTree = ({ contextMenuObj, callbacks, userSettings, userPermissions }) => {
	return [
		{
			name: "Протокол",
			subgroups: [
				{
					name: "Subgroup",
					items: [
						{
							label: "Экспорт протокола",
							icon: <FileOpenOutlinedIcon />,
							type: "common",
							callback: () => {
								callbacks.exportProtocolContextMenu({ clickedRow: contextMenuObj });
								callbacks.closeContextMenu();
							},
							disabled: false,
						},
						{
							label: "Заливка",
							icon: <FillColorSeparateIcon secondaryColor={userSettings?.USER_COLORS?.last_color} />,
							type: "common",
							callback: () => {
								callbacks.fillColorTableRow({ hex: userSettings?.USER_COLORS?.last_color });
								callbacks.closeContextMenu();
							},
						},
					],
				},
			],
		},
		{
			name: "Протокол",
			isVisible: userPermissions.is_expert === true && userSettings?.projectTree?.lsrStatusUsage === true,
			subgroups: [
				{
					name: "Subgroup",
					items: [
						{
							label: "Согласовано",
							isVisible: userPermissions.is_expert === true && userSettings?.projectTree?.lsrStatusUsage === true,
							icon: <CheckCircleOutlinedIcon style={{ color: "var(--tree-row-valid)" }} />,
							type: "common",
							callback: () => {
								callbacks.applyValidToProjectTreeRow({ status: ExpertEstmStatusEnum.VALID });
								callbacks.closeContextMenu();
							},
						},
						{
							label: "Вернули на доработку",
							isVisible: userPermissions.is_expert === true && userSettings?.projectTree?.lsrStatusUsage === true,
							icon: <HighlightOffOutlinedIcon style={{ color: "var(--tree-row-not-valid)" }} />,
							type: "common",
							callback: () => {
								callbacks.applyValidToProjectTreeRow({ status: ExpertEstmStatusEnum.NOT_VALID });
								callbacks.closeContextMenu();
							},
						},
					],
				},
			],
		},
		{
			name: "Печатная форма",
			subgroups: [
				{
					name: "Subgroup",
					items: [
						{
							label: "Печать документа",
							icon: <PrintOutlinedIcon />,
							type: "common",
							callback: () => {
								callbacks.printDocContextMenu(false);
								callbacks.closeContextMenu();
							},
							disabled: false,
						},
						{
							label: "Печать с ошибками",
							icon: <LocalPrintshopTwoToneIcon />,
							type: "common",
							callback: () => {
								callbacks.printDocContextMenu(true);
								callbacks.closeContextMenu();
							},
							disabled: !["local", "kats"].includes(contextMenuObj.type),
						},
					],
				},
			],
		},
		{
			name: "",
			subgroups: [
				{
					name: "Subgroup",
					items: [
						{
							label: "Экспорт в XML",
							icon: <FileDownloadOutlinedIcon />,
							type: "common",
							callback: () => {
								callbacks.exportXmlDocContextMenu({ clickedRow: contextMenuObj });
								callbacks.closeContextMenu();
							},
							disabled: false,
						},
						{
							label: "Комментарий",
							icon: <FileOpenOutlinedIcon />,
							type: "common",
							callback: () => {
								callbacks.showProjectTreeComment({ targetRow: contextMenuObj });
								callbacks.closeContextMenu();
							},
							disabled: contextMenuObj.type === "summary",
						},
						{
							label: "Удалить документ",
							icon: <DeleteOutlinedIcon />,
							type: "common",
							callback: () => {
								callbacks.deleteDocContextMenu({ cascade: true });
								callbacks.closeContextMenu();
							},
							isVisible: contextMenuObj.type !== "summary",
						},
						{
							label: "Удалить документ без ЛСР",
							icon: <DeleteOutlinedIcon />,
							type: "common",
							callback: () => {
								callbacks.deleteDocContextMenu({ cascade: false });
								callbacks.closeContextMenu();
							},
							isVisible: contextMenuObj.type === "object",
						},
						{
							label: "Удалить ССР в БЦ",
							icon: <DeleteOutlinedIcon />,
							type: "common",
							callback: () => {
								callbacks.deleteDocContextMenu({ priceLevel: "base" });
								callbacks.closeContextMenu();
							},
							isVisible: contextMenuObj.type === "summary",
						},
						{
							label: "Удалить ССР в ТЦ",
							icon: <DeleteOutlinedIcon />,
							type: "common",
							callback: () => {
								callbacks.deleteDocContextMenu({ priceLevel: "current" });
								callbacks.closeContextMenu();
							},
							isVisible: contextMenuObj.type === "summary",
						},
						{
							label: "Скопировать документ",
							icon: <ContentCopyOutlinedIcon />,
							type: "common",
							callback: () => {
								callbacks.copyEstimateDoc();
								callbacks.closeContextMenu();
							},
							disabled: !["local", "vor"].includes(contextMenuObj.type),
						},
						{
							label: "Сделать актуальным",
							icon: <LowPriorityOutlinedIcon />,
							type: "common",
							callback: () => {
								callbacks.closeContextMenu();
								callbacks.showDedublicateDialog({
									callback: () => {
										callbacks.makeLsrDoubleWinner();
									},
								});
							},
							disabled: !["local"].includes(contextMenuObj.type),
							isVisible: (contextMenuObj.type === "local") & (contextMenuObj?.double_is_winner === false),
						},
					],
				},
			],
		},
	];
};

export { EstimateViewerContextMenuProjectTree };
